import { AppService } from "app/services/app.service";

import { Porta } from "app/models/porta";
import { Observable } from "rxjs";

export abstract class AbPorta extends AppService {
  abstract getPortas(): Observable<any>;
  abstract getPortasAtivas(): Observable<any>;
  abstract getPortasAtivasReduzidas(): Observable<any>;
  abstract getPortaById(id: number): Observable<any>;
  abstract getPortaByIdDto(id: number): Observable<any>;
  abstract salvar(entity): Observable<any>;
  abstract getPortasInativasPromise();
  abstract getPortasAtivasPromise();
  abstract salvarAlterarPortaPromise(porta: Porta);
}